import { TalaveraTile } from "./TalaveraTile";

export const TalaveraStrip = ({ count = 5, className = "" }) => (
  <div className={`flex justify-center items-center gap-3 md:gap-4 ${className}`} aria-hidden="true">
    {Array.from({ length: count }).map((_, i) => (
      <TalaveraTile key={i} className={`w-8 h-8 md:w-10 md:h-10 ${i % 2 === 1 ? "rotate-45" : ""}`} />
    ))}
  </div>
);
